/**
 * Gets title from account info.
 * Tries to get those from either `idTokenClaims` or `name` or `username`.
 * @param account Account info to get titlle from.
 */
export var getTitleFromAccount = function (account) {
    var idTokenClaims = account.idTokenClaims, name = account.name, username = account.username;
    // Try to get full name from account id token claims
    if (idTokenClaims) {
        var _a = idTokenClaims, given_name = _a.given_name, family_name = _a.family_name;
        if (given_name || family_name) {
            return ((given_name || '') + " " + (family_name || '')).trim();
        }
    }
    // Try to get name or username from account
    return name || username || '';
};
